module.exports = __webpack_public_path__ + "assets\\img\\svg_sprite\\svg_sprite.svg?963ca284ae4e8ba3f489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg_sprite/svg_sprite.svg
// module id = 154
// module chunks = 0